import { registerDecorator } from 'class-validator';
import { mod10Validation } from './luhn';

export function AhnFormat() {
  return function (object, propertyName: string) {
    registerDecorator({
      name: 'AhnFormat',
      target: object.constructor,
      propertyName: propertyName,
      validator: {
        validate(ahn: string) {
          const mod10 = mod10Validation(ahn, 5);
          return mod10 === null; //{ mod10Validation: true } result means failure!
        },
        defaultMessage(): string {
          return 'AHN must be a valid AHN';
        },
      },
    });
  };
}
